import { createI18n } from 'vue-i18n'
import zhTW from './locales/zh-TW.json'
import enUS from './locales/en-US.json'

export type MessageSchema = typeof zhTW
export type SupportedLocale = 'zh-TW' | 'en-US'

const LOCALE_KEY = 'solarsdgs-locale'

export function getStoredLocale(): SupportedLocale {
  const stored = localStorage.getItem(LOCALE_KEY)
  if (stored === 'zh-TW' || stored === 'en-US') {
    return stored
  }
  return 'zh-TW'
}

export function setStoredLocale(locale: SupportedLocale): void {
  localStorage.setItem(LOCALE_KEY, locale)
}

const i18n = createI18n({
  legacy: false,
  locale: getStoredLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'zh-TW': zhTW,
    'en-US': enUS,
  },
})

export function setLocale(locale: SupportedLocale): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (i18n.global.locale as any).value = locale
  setStoredLocale(locale)
  document.documentElement.lang = locale
}

export function getCurrentLocale(): SupportedLocale {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (i18n.global.locale as any).value as SupportedLocale
}

export default i18n
